import { Box, Button, Grid2, Typography } from '@mui/material';
import { useMemo } from 'react';
import useAuthStore from '../../../store/useAuthStore';
import { useToaster } from '../../utils/ToasterProvider';
// import api from '../../../assets/api/useStudentPostApi';
import { getFormattedDate1 } from '../../formatter';
import { useMutation } from '@tanstack/react-query';
import api from '../../../assets/nodeApi/axiosInstance';

const InfoTag = ({ children }) => {
    return (
        <Typography
            variant="body2"
            sx={{
                bgcolor: '#E5E5E5',
                borderRadius: 0.5,
                p: 1,
            }}
        >
            {children}
        </Typography>
    );
};

const MeetingCard = ({ item, detail }) => {
    const { user, token } = useAuthStore()
    const {
        day,
        meeting_id,
        date,
        start_time_utc,
        student_link,
        teacher_link,
        duration_minutes
    } = item;

    const {
        batch_id,
        course_id,
        batch_instructor_id,
        batch_apartment_id,
    } = detail;



    // const { showJoinButton, isCompleted } = useMemo(() => {
    //     const startTime = new Date(start_time_utc);
    //     const now = new Date();

    //     const tenMinutesBefore = new Date(startTime.getTime() - 10 * 60 * 1000);

    //     return {
    //         showJoinButton: now >= tenMinutesBefore && now < startTime,
    //         isCompleted: now >= startTime,
    //     };
    // }, [start_time_utc]);

    const { showJoinButton, isCompleted } = useMemo(() => {
        const startTime = new Date(start_time_utc);
        const now = new Date();

        const tenMinutesBefore = new Date(startTime.getTime() - 10 * 60 * 1000);

        const durationMinutes = duration_minutes || 60; // fallback to 60 if not provided
        const endTime = new Date(startTime.getTime() + durationMinutes * 60 * 1000);

        return {
            showJoinButton: now >= tenMinutesBefore && now < endTime,
            isCompleted: now >= endTime,
        };
    }, [start_time_utc, duration_minutes]);
   
    const { showToaster } = useToaster();
   
    const createMutation = useMutation({
        mutationFn: (formData) => api.post("student-attendance/create", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }),
    });

    const handleStudentAtd = () => {
        const obj = {
            student_data: [{
                "student_id": user?.id,
                "attendance_status": "1",
                "remarks": "Good engagement"
            }],
            trainer_id: batch_instructor_id,
            attendance_date: getFormattedDate1(),
            course_id: course_id,
            batch_id: batch_id,
        }
        createMutation.mutate(obj, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    showToaster('Student Marked Present', '', 'success')
                } else {
                    showToaster('Something went wrong!', '', 'error')
                }
            },
            onError: (error) => {
                showToaster(error?.data?.error || 'Something went wrong', '', 'error')
            }

        });

    }
    const createTrainerAtdMutation = useMutation({
        mutationFn: (formData) => api.post("trainer-attendance/store", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }),
    });
    const handleTrainerAtd = () => {
        const obj = {
            "course_id": course_id,
            "trainer_id": user?.id,
            "apartment_id": batch_apartment_id,
            "attendance_status": 1,
            "batch_id": batch_id,
            "facility_id": null
        };
        createTrainerAtdMutation.mutate(obj, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    showToaster(response?.data?.message, '', 'success')


                } else {
                    showToaster('Something went wrong!', '', 'error')
                }
            },
            onError: (error) => {
                showToaster(error?.data?.error, '', 'error')
            }
        });

    }

    return (
        <Grid2
            container
            sx={{
                padding: '1rem 2rem',
                bgcolor: '#F2F2F2',
                borderRadius: '1rem',
                my: '3rem',
            }}
        >
            <Grid2 size={7}>
                <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                    <InfoTag>{day}</InfoTag>
                    <InfoTag>Meeting ID : {meeting_id}</InfoTag>
                </Box>

                <Box sx={{ display: 'flex', gap: 1 }}>
                    <InfoTag>Date: {date}</InfoTag>
                    <InfoTag>Time : {new Date(start_time_utc).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</InfoTag>
                </Box>
            </Grid2>

            <Grid2 container size={5} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Grid2 size={5}>
                    {isCompleted ? (
                        <Button variant="contained" fullWidth disabled>
                            Completed
                        </Button>
                    ) : (
                        <Button
                            variant="contained"
                            fullWidth
                            disabled={!showJoinButton}
                            onClick={() => {
                                if (user?.role === "trainer") {
                                    window.open(teacher_link, '_blank');
                                    handleTrainerAtd();
                                } else {
                                    window.open(student_link, '_blank');
                                    handleStudentAtd();
                                }
                            }}
                        >
                            {user?.role === "trainer" ? "Start" : "Join"}
                        </Button>

                    )}
                </Grid2>
            </Grid2>
        </Grid2 >
    );
};

export default MeetingCard;
